<template>
  <v-container>
    <v-row justify="center" class="center">
      <v-col        
      col="12"
      sm="6"
      md="6"
      lg="5"
      xl="3"
      >
        <v-row>
          <v-col cols="12" class="pb-0 pt-0 pb-md-2 pt-md-2 pt-lg-2 pb-lg-2">
            <div class="secondary--text text-uppercase text-h4 text-sm-h4  text-lg-h2 text-center">
              <span class="font-weight-medium font-italic font-bold">Rapid</span>
              <span> Quote</span>
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class= "pb-0 pt-0 pb-md-2 pt-md-2 pt-lg-2 pb-lg-2">
            <div class="secondary--text text-uppercase text-body-2 text-sm-body text-md-h6 text-center font-weight-light">
              it’s all about the data
            </div>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
              <v-card class="primary">
                <v-card-text>
                  <v-container>
                      <v-col cols="12">
                        <div class="headline secondary--text text-md-h4 text-sm-h5 text-h4 text-center">Login</div>
                      </v-col>
                      <v-row>
                          <v-col cols="12">
                            <v-text-field 
                              color="secondary"
                              dark
                              v-model="email"
                              label="Email" 
                              :error-messages="emailErrors"
                              required
                              v-on:keyup.enter="submit"
                              @input="$v.email.$touch()"
                              @blur="$v.email.$touch()"
                              ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              color="secondary"
                              dark
                              append-icon="mdi-lock"
                              v-model="password"
                              label="Password"
                              :error-messages="passwordErrors"
                              type="password"
                              required
                              v-on:keyup.enter="submit"
                              @input="$v.password.$touch()"
                              @blur="$v.password.$touch()"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="mt-sm-0 mt-md-7">
                            <v-btn
                            color="secondary primary--text" 
                            class="mr-4" 
                            block 
                            large 
                            @click="submit">
                              Login
                              <v-icon right dark>mdi-arrow-right-circle</v-icon>
                            </v-btn>
                          </v-col>
                          <v-spacer></v-spacer>
                      </v-row>                      
                  </v-container>
                  <v-row justify="center">
                    <v-col cols="12" md="5">
                      <v-btn color="light-blue lighten-1" block text to="/reset" class="mr-4">forgot password</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
          </v-col>
        </v-row>
        <v-dialog
        v-model="restrictIE"
        :retain-focus="false"
        persistent
        max-width="360px">
          <v-card class="mt-6 section" >
            <v-card-title class="primary section-title">
              <v-spacer></v-spacer>
              <span class="red--text font-weight-bold">Internet Explorer!</span>
              <v-spacer></v-spacer>
            </v-card-title>
              <v-card-text class="text-justify"><br>
                  We're sorry, Internet Explorer
                  is not a supported browser.
                  Please use a modern browser
                  to access Rapid Quote.
              </v-card-text>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import { validationMixin } from 'vuelidate';
  import { required, email, minLength } from 'vuelidate/lib/validators';
  import { mapActions, mapGetters } from 'vuex';
  export default {
    mixins: [validationMixin],
    
    data: () => ({
      email: '',
      password: '',
      restrictIE: false,
    }),

    mounted() {
      // destroy any token when on the login page
      const ua = window.navigator.userAgent;
      const msie = ua.indexOf('MSIE');
      if (msie !== -1) {
        this.restrictIE = true;
      }
    },

    validations: {
      email: { required, email },
      password: { required, minLength: minLength(10)}
    },
    
    computed: {
      ...mapGetters ({
      }),
      emailErrors () {
        const errors = [];
        if (!this.$v.email.$dirty) return errors;
        !this.$v.email.email && errors.push('Must be a valid e-mail.');
        !this.$v.email.required && errors.push('E-mail is required.');
        return errors;
      },
      passwordErrors () {
        const errors = [];
        if (!this.$v.password.$dirty) return errors;
        !this.$v.password.required && errors.push('Password is required.');
        return errors;
      },
    },

    methods: {
      ...mapActions(['login']),
      submit () {
        this.$v.$touch();
        let authData = {
          username: this.email.toLowerCase(),
          password: this.password,
        };
        this.login(authData);
      },
      // clear () {
      //   this.$v.$reset();
      //   this.email = '';
      //   this.password = '';
      // },
    },
    components: {},
  };
</script>

<style scoped>
    .center {
      margin-top:1vh;
    }
    
    .login-sm {
      height: 200vh;
    }
    
    .login {
      background: radial-gradient(#505CBE, #282E5F);
      height: 100vh;
    }

    input[type="password"]::v-deep {
      background-color: red !important;
    }
</style>